<template lang="pug">

.actionList
  template(v-for="history in histories")
    .date
      h1 {{ showDate(history.date) }}
      template(v-for="data in history.data")
        .event
          span.time {{ data.time }}
            img(:class="data.device.type" :src="showImage(data.device.type)")
          .label
            span.type {{ showActions(data.event.type) }}
            router-link(:to="{ name:'analysisEventDetail', params:{ id: data.event.id }}")
              span.action {{ data.event.name }}
          span.message(v-html="showMessage(data)")
  .addlist
    el-button(v-if="displayMoreButton" size="mini" :loading="isEventlistLoading" @click="loadEvents()") {{ $t('Analysis.User.reload', {num:pageSize}) }}


</template>

<script>
import actions from '@/utils/defines/actions.js';
import dateFns from '@/utils/defines/date.js';
import API from '@/api/v2/customers';
import Vue from 'vue';
import moment from 'moment';

export default {
  data () {
    return {
      isEventlistLoading: false,
      eventHash: { },
      totalHistoryCount: 0,
      pageSize: 10,
      images:{
        cube: require('@/assets/cuona_cube.png'),
        tag: require('@/assets/cuona_tag.svg')
      }
    }
  },
  computed: {
    histories() {
      const result = [ ];
      for (const day of Object.keys(this.eventHash).sort().reverse()) {
        result.push({
          date: new Date(day),
          data: this.eventHash[day]
        });
      }
      return result;
    },
    displayedHistoriesCount() {
      return Object.values(this.eventHash).reduce((a,v)=>a+=v.length, 0);
    },
    displayMoreButton() {
      return this.displayedHistoriesCount < this.totalHistoryCount;
    }
  },
  mixins: [actions, dateFns],
  methods: {
    loadEvents: function(reload){
      const that = this;
      if (reload) {
        this.currentPage = 0;
      }
      const reqParams = {
        page_size: this.pageSize,
        page: this.currentPage + 1,
      };
      API.getCustomerDeviceLogs(this.$route.params.id, reqParams).then(function(response) {
        if (response && response.device_logs !== undefined) {
          that.addEvents(response.device_logs, reload);
          that.currentPage = that.currentPage + 1;
        }
        if (response && response.device_logs_count !== undefined) {
          that.setCount(response.device_logs_count);
        }
      });
    },
    addEvents(array, reset) {
      if (reset) {
        this.eventHash = { };
      }
      for (const el of array) {
        const dateObj = moment(el.used_at);
        const date = dateObj.format('YYYY-MM-DD');
        el['time'] = dateObj.format('HH:mm:ss');
        if (!this.eventHash[date]) {
          Vue.set(this.eventHash, date, [ ]);
        }
        this.eventHash[date].push(el);
      }
    },
    setCount: function(count) {
      this.totalHistoryCount = count;
    },
    showDate: function(date){
      return this.getDate(date);
    },
    showActions: function(type){
      for(var i=0; i<this.actions.length; i++){
        if (this.actions[i].type == type){
          return this.$t(this.actions[i].name);
        }
      }
    },
    showMessage(data) {
      return this.$t('Analysis.User.touch_desc_default', {
        link: "/analysis/device/" + data.device.nfc_uid,
        device: data.device.name
      } )
    },
    showImage(type) {
      switch (type) {
        case "cube":
          return this.images.cube
        case "tag":
          return this.images.tag
        default:
          return this.images.tag
      }
    }
  },
  mounted() {
    this.loadEvents(true);
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.el-table ::v-deep {
  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0;
    color: #999;

  }
  td.logcell {
    padding: 5px 0;
    font-size: 13px;
  }
  .cell {
    padding-left: 2px;
  }
}

.actionList {
  position: relative;

  &:before {
    content: "";
    border-left: 1px solid $border;
    display: block;
    position: absolute;
    width: 2px;
    margin: 27px 0 0 68px;
    height: 100%;
  }
  .date {
    position: relative;

    h1 {
      display: inline-block;
      position: relative;
      font-size: 14px;
      padding: 3px 8px;
      border: 1px solid $border;
      background: #FFF;
      border-radius: 20px;
      height: 20px;
      min-width: 120px;
      font-weight: normal;
      text-align: center;
    }
  }

  .event {
    transition: all .3s ease-in-out;
    padding: 5px 3px;
    &:hover {
      background: rgba(58,179,232,0.1);
      border-radius: 5px;
    }

    span.time {
      font-size: 14px;
      background: url("../../../assets/arrow-timeline.svg") no-repeat left center;
      margin: 0 0 0 63px;
      padding: 0 0 0 40px;

      img {
        width: 26px;
        margin-left: 5px;
        vertical-align: top;
        margin-right: 5px;
      }
    }

    .label {
      display: inline-block;
      background: $border;
      padding: 3px 12px;
      border-radius: 20px;
      margin-right: 10px;
      font-size: 12px;

      span {
        &.type {
          &:after {
            content: ":";
            padding: 0 3px;
          }
        }
      }
    }

    header {
      transition: all .3s ease-in-out;
      display: inline-block;
      text-align: center;
      background: $border;
      box-shadow: 0 0 0 2px $border;
      border-radius: 5px;
      margin: 0 10px 0 0;

      span {
        display: inline-block;
        font-size: 14px;

        &.action {
          transition: all .3s ease-in-out;
          line-height: 1;
          padding: 3px 6px;
          min-width: 120px;
        }
      }
    }
    .message {
      font-size: 14px;
    }
  }

  .addlist {
    margin-top: 30px;

    .el-button {
      position: relative;
    }
  }
}
</style>
